import { ChatEvent, CustomerData, WidgetState } from '@livechat/widget-react';

import { OPEN_LIVE_CHAT_HASH } from './constants';

export const getQueryParam = (name: string) => {
    const getParam = name.replace(/\[/, '\\[').replace(/\]/, '\\]');
    const regex = new RegExp(`[\\?&]${getParam}=([^&#]*)`);
    const results = regex.exec(window.location.search);

    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

export const initLiveChatGlobalVars = (chatGroup?: number) => {
    window.LC_VARS = window.LC_VARS || [];
    window.__lc = window.__lc || {};

    if (chatGroup) {
        window.__lc.group = chatGroup;
    }
};

export const openLiveChat = () => {
    if (window.location.hash === OPEN_LIVE_CHAT_HASH) {
        window.location.hash = '';
    }

    window.LiveChatWidget.call('maximize');
};

export const hideLiveChat = () => {
    window.LiveChatWidget.call('minimize');
};

export const closeLiveChat = () => {
    window.LiveChatWidget.call('hide');
};

export const addCustomVariable = (name: string, value: string) => {
    window.LC_VARS.push({ name, value });
};

export const sendCustomVariables = () => {
    if (window.LC_VARS.length) {
        window.LiveChatWidget.call(
            'set_session_variables',
            window.LC_VARS.reduce<Record<string, string>>((acc, next) => ({ ...acc, [next.name]: next.value }), {}),
        );
    }
};

export const runOnLiveChatReady = (callback: (data: { state: WidgetState; customerData: CustomerData }) => void) => {
    window.LiveChatWidget.on('ready', callback);
};

export const runOnVisibilityChanged = (callback: (visibility: Pick<WidgetState, 'visibility'>) => void) => {
    window.LiveChatWidget.on('visibility_changed', callback);
};

export const runOnCustomerStatusChanged = (callback: (data: CustomerData) => void) => {
    window.LiveChatWidget.on('customer_status_changed', callback);
};

export const runOnNewEvent = (callback: (event: ChatEvent) => void) => {
    window.LiveChatWidget.on('new_event', callback);
};

export const isChatRunning = () => {
    const state: CustomerData = window.LiveChatWidget.get('customer_data');

    return state.status === 'chatting';
};

export const isChatWindowMaximized = () => {
    const state: WidgetState = window.LiveChatWidget.get('state');

    return state.visibility === 'maximized';
};

export const areChatAgentsAvailable = () => {
    const state: WidgetState = window.LiveChatWidget.get('state');

    return state.availability === 'online';
};
